export default __webpack_public_path__ + "src/images/packages/monte-vista-boutique-hotel/84894390bd10fcd500d726256926c10c-5.jpg";